<template>
  <div>
    <div class="Navbar">
      <div class="NavbarContent">
        <div class="NavbarLogo">
          <a href="#">
            <img src="../assets/img/logo_white.svg" alt="logo" />
          </a>
        </div>
        <div class="NavbarMenu">
          <Loader v-if="loading" />
          <div v-else>
            <div v-if="isSignedIn" class="signedInMenu">
              <p v-if="isPremium" class="premiumLabel">
                Premium
              </p>
              <div class="signedInMenuPhoto">
                <img v-bind:src="getUser.photoURL" alt="user photo" />
              </div>
              <div class="signedInMenuName">
                <p>{{ getUser.displayName }}</p>
              </div>
              <img
                class="signOutIcon"
                @click="signOut"
                src="../assets/img/logout.svg"
                alt="sign out"
              />
            </div>
            <GoogleLoginButton :setLoading="setLoading" v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GoogleLoginButton from './GoogleLoginButton';
import Loader from './Loader';

export default {
  name: 'Navbar',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    GoogleLoginButton,
    Loader,
  },
  created() {
    this.refreshUser(this.getUser);
  },
  methods: {
    ...mapActions(['signOut', 'refreshUser']),
    setLoading(bool) {
      this.loading = bool;
    },
  },
  computed: {
    ...mapGetters(['getUser', 'isSignedIn', 'isPremium']),
  },
};
</script>

<style lang="scss" scoped>
.Navbar {
  .NavbarContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 15px 0;
  }
  .NavbarLogo {
    a {
      font-weight: 700;
      font-size: 28px;
      color: $color-white;
      text-decoration: none;
      img {
        width: 140px;
      }
    }
  }
  .NavbarMenu {
    display: flex;
    align-items: center;
  }
  .signedInMenu {
    display: flex;
    align-items: center;
  }
  .signedInMenuPhoto {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 1px solid $color-purple;
    }
  }
  .signedInMenuName {
    margin-right: 15px;
    color: $color-white;
  }
  .premiumLabel {
    margin-right: 15px;
    color: $color-purple;
  }
  .signOutIcon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}

@media screen and (max-width: 650px) {
  .Navbar {
    .NavbarLogo {
      img {
        height: 18px;
      }
    }
    .signedInMenuName {
      display: none;
    }
    .NavbarBtn {
      font-size: 15px;
    }
    .signOutIcon {
      margin-left: 10px;
    }
  }
}
</style>
